module.exports = __webpack_public_path__ + "img/tiramisu-2.82c7cc92.jpg";